<template>
  <b-table
    class="statistic-detail"
    :data="data.data"
    @page-change="changePage"
    default-sort="id"
    backend-sorting
    backend-pagination
    :total="data.total"
    per-page="15"
    paginated
    pagination-simple
    pagination-size="is-small"
  >
      <template slot-scope="props" class="user-detail">
        <b-table-column 
          label="Название урока" 
          :visible="true" 
          field="stage_name" 
          :centered="false" 
          sortable
          width="40%"
        >
          <div>{{ props.row.stage_name }}</div>
        </b-table-column>

         <b-table-column
          label="Статус"
          :visible="true"
          field="status"
          :centered="false"
          width="15%"
        > 
          <div> {{ props.row.status }}</div>
        </b-table-column>
        <b-table-column
          label="Прогресс"
          :visible="true"
          field="correct_answers_count"
          :centered="false"
          sortable
          width="25%"
        >
          <div>{{ progress(props.row) }}%</div>
        </b-table-column>
        <b-table-column
          :visible="true"
          :centered="false"
          sortable
          width="20%"
        >
          <div>
            <a @click="$emit('openModal', user.branch_id, props.row.user_test_attempt_id)" class="download">Скачать протокол</a>
          </div>
        </b-table-column>
      </template>
  </b-table>
</template>
<script>

export default({
  name: 'CourseStatisticUsersTableDetail',
  props: {
    data: {
      default: () => {},
      type: Object
    },
    user: {
      default: () => {},
      type: Object
    },
    totalCount: {
      default: () => 0,
      type: Number
    },
  },
  methods: {
    changePage(val) {
      this.$emit('changePage', val)
    },
    progress(row) {
      return `${row.correct_answers_count}/${row.question_count}, 
        ${(row.correct_answers_count / row.question_count * 100).toFixed(0)}`
    },
  },
})
</script>
